import { Observable } from 'rxjs';
import { CreateCustomerRequest } from '../models/customer-create.model';
import { CustomerModel } from '../models/customer-list.model';
import { CustomerProfileModel, CustomerProfileResponse } from "../models/customer-profile.model";
import { EditCustomerRequest } from '../models/customer-edit.model';
import { CustomerPermissionsPayload } from '../models/customer-permissions.model';
import { Modules } from '../utils/enums';
import {CreateCustomerPatientRequest} from "@shared/models/patient/create-customer-patient.request";
import {CustomerPatient} from "@shared/models/patient/customer-patients-list.model";
import {PatientInvoicesResponse} from "@shared/models/patient/patient-invoices.response";
import {CustomerInvoicesResponse} from "@shared/usecases/customer/customer-invoices.response";

//
export abstract class CustomerRepository {
  abstract changeCustomerStatus(statusModel: {
    customerId: string;
    isActive: boolean;
  }): Observable<any>;

  abstract createCustomerProfile(
    customerProfileModel: CustomerProfileModel
  ): Observable<any>;

  abstract createCustomerWithCustomerAdmin(
    customer: CreateCustomerRequest
  ): Observable<any>;

  abstract getAllCustomers(): Observable<CustomerModel []>;

  abstract setCustomerPermissions(
    param: CustomerPermissionsPayload
  ): Observable<any>; // put request

  abstract getCustomerPermissions(customerId: string): Observable<Modules[]>;

  abstract getCustomerProfile(id: string): Observable<CustomerProfileResponse>;

  abstract updateCustomerProfile(
    editModel: EditCustomerRequest
  ): Observable<any>;

  abstract postCustomerPatient(request : CreateCustomerPatientRequest): Observable<string>;

  abstract getAllPatients() : Observable<CustomerPatient[]>;

  abstract getPatientTransactions() : Observable<PatientInvoicesResponse[]>;
  abstract getCustomerTransactions(customerId : string) : Observable<CustomerInvoicesResponse[]>;
  abstract removeCustomerPatient(customerId : string, patientIs : string) : Observable<any>;
}
